import type { StateManager } from './state';

export class TickLoop {
  private rafId: number | null = null;
  private lastFrameTime = 0;
  private running = false;

  constructor(private stateManager: StateManager) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastFrameTime = performance.now();
    this.loop(this.lastFrameTime);

    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  stop(): void {
    this.running = false;
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  private loop = (now: number): void => {
    if (!this.running) return;

    const deltaMs = now - this.lastFrameTime;
    this.lastFrameTime = now;

    if (!document.hidden) {
      const deltaSeconds = deltaMs / 1000;
      this.stateManager.update(deltaSeconds);
    }

    this.rafId = requestAnimationFrame(this.loop);
  };

  private onVisibilityChange = (): void => {
    if (!document.hidden) {
      this.lastFrameTime = performance.now();
    }
  };
}
